<template>
    <div id="taskManagement">
        <el-row style="border: 1px solid #DEDEDE;height: 220px;padding:10px 0px;margin-bottom: 10px">
            <el-col style="">
                <div style="width: 10px;height: 30px;background-color: #4BBFEF;display:inline-block"></div>
                <span style="font-weight: bold;font-size: 18px;position: relative;bottom: 5px">任务汇总</span>
            </el-col>
            <el-col style="margin:25px 0px 20px 0px;display: flex;justify-content: center;align-items: center">
                <div style="height: 120px;color: #13ACE7;display: flex;flex-direction: column;justify-content: center;align-items: center;">
                    <span style="font-size: 50px;display:block;">{{count.task_num}}</span>
                    <span style="font-size: 20px;display:block;margin-top:25px">任务</span>
                </div>
                <div style="height: 80px;width: 1px;background-color: #D8D8D8;margin: 8px 50px 0px 50px;"></div>
                <div style="height: 120px;color: #FF9901;display: flex;flex-direction: column;justify-content: center;align-items: center;">
                    <span style="font-size: 50px;display:block;">{{count.schedule_num}}</span>
                    <span style="font-size: 20px;display:block;margin-top:25px">运行计划</span>
                </div>
                <div style="height: 80px;width: 1px;background-color: #D8D8D8;margin: 8px 50px 0px 50px;"></div>
                <div style="height: 120px;color: #60C8BD;display: flex;flex-direction: column;justify-content: center;align-items: center;">
                    <span style="font-size: 50px;display:block;">{{count.log_num}}</span>
                    <span style="font-size: 20px;display:block;margin-top:25px">本月运行</span>
                </div>
                <div style="height: 80px;width: 1px;background-color: #D8D8D8;margin: 8px 50px 0px 50px;"></div>
                <div style="height: 120px;color: #ED3B3F;display: flex;flex-direction: column;justify-content: center;align-items: center;">
                    <span style="font-size: 50px;display:block;">{{count.failed_num}}</span>
                    <span style="font-size: 20px;display:block;margin-top:25px">运行失败</span>
                </div>
                <div style="height: 80px;width: 1px;background-color: #D8D8D8;margin: 8px 50px 0px 50px;"></div>
                <div style="height: 120px;color: #ED3B3F;display: flex;flex-direction: column;justify-content: center;align-items: center;">
                    <span style="font-size: 50px;display:block;">{{count.last_num}}</span>
                    <span style="font-size: 20px;display:block;margin-top:25px">昨日失败</span>
                </div>
            </el-col>
        </el-row>
        <el-row v-for="item in taskArray">
           <el-row style="border: 1px solid #DEDEDE;margin-top: 10px">
            <el-col style="padding:15px 20px;background-color:#EEF2F6;border-bottom: 1px solid #DEDEDE">
                <div style="">
                    <span style="display: block;font-size:18px">{{item.task_name}}</span>
                    <el-row style="margin: 5px 0">
                        <el-col :span="20" style="display: inline-block;color: #717D84;font-size:14px;line-height:20px;">{{item.comments?item.comments:'暂无任务说明'}}</el-col>
                        <el-col :span="4" style="display: flex;justify-content: flex-end;line-height:20px;"><span style="font-size: 14px">启用</span>
                            <el-switch
                                    style="margin-left: 5px"
                                    v-model="item.status"
                                    :width="35"
                                    active-value="ACTIVE"
                                    inactive-value="INACTIVE"
                                    active-color="#44DB5E"
                                    disabled
                            >
                            </el-switch>
                        </el-col>
                    </el-row>
                    <span style="color:#4A90E2;font-size:14px">最后一次的运行时间：{{item.lastOperation}}</span>
                </div>
            </el-col>
            <el-col style="padding: 20px">
                <div style="border: 1px solid #FF9901;border-radius: 4px;width: 35px;height: 18px;line-height: 18px;font-size: 13px;text-align: center;color:#FF9901;display: inline-block;margin-right: 10px ">{{item.task_type}}</div>
                <span style="font-size: 16px;color:#585757 ">{{item.program}}</span>
            </el-col>
            <el-col style="padding: 0 20px ">
                <el-button :disabled="item.status=='INACTIVE'" style="border-color:#4EC880;background-color: #4EC880" type="success" size="small" icon="el-icon-plus" @click.stop="addSchedule(item.task_name,item.task_id)">添加新的运行计划</el-button>
            </el-col>
            <el-col style="padding:10px 20px">
                <el-table
                        :data="item.scheduleArr"
                        border
                >
                    <el-table-column
                            fixed
                            width="60"
                            type="index"
                            label="序号"
                    >
                    </el-table-column>
                    <el-table-column
                            min-width="200"
                            prop="schedule_name"
                            label="运行计划"
                            sortable
                    >
                    </el-table-column>
                    <el-table-column
                            width="80"
                            sortable
                            prop="month"
                            label="月份">
                        <template slot-scope="scope">
                            {{scope.row.month==0?"-":scope.row.month}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            width="100"
                            sortable
                            prop="weekday"
                            label="星期几"
                    >
                        <template slot-scope="scope">
                            {{scope.row.weekday==0?"-":scope.row.weekday}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            width="60"
                            sortable
                            prop="day"
                            label="日"
                    >
                        <template slot-scope="scope">
                            {{scope.row.day==0?"-":scope.row.day}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            width="60"
                            sortable
                            prop="hour"
                            label="时">
                        <template slot-scope="scope">
                            <div v-if="scope.row.hour==''">
                                -
                            </div>
                            <div v-else>
                                {{scope.row.hour}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            width="60"
                            sortable
                            prop="minute"
                            label="分"
                    >
                        <template slot-scope="scope">
                            <div v-if="scope.row.minute==''">
                                -
                            </div>
                            <div v-else>
                                {{scope.row.minute}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            width="60"
                            sortable
                            prop="second"
                            label="秒"
                    >
                        <template slot-scope="scope">
                           <div v-if="scope.row.second==''">
                               -
                           </div>
                            <div v-else>
                                {{scope.row.second}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            width="110"
                            sortable
                            prop="lastStatus"
                            label="最近状态">
                        <template slot-scope="scope">
                            <div v-if="scope.row.lastStatus=='T'" style="font-weight: bold;color: #7ED321">成功</div>
                            <div v-if="scope.row.lastStatus=='F'" style="font-weight: bold;color: #ED3B3F">失败</div>
                            <div v-if="scope.row.lastStatus==''">-</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            width="150"
                            label="操作"
                            label-class-name="taskManagement_table_cell"
                    >
                        <template slot-scope="scope">
                            <el-button style="border-color:#FF9901;background-color: #FF9901" @click="setting(item, scope.row)" type="warning" size="mini">设置
                            </el-button>
                            <el-button @click="logBtn(item,scope.row)" type="primary" size="mini">日志
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
           </el-row>
        </el-row>
<!--        设置/添加-->
        <el-dialog id="setting"
                :visible.sync="dialog1"
                width="600px"
                :show-close="false"
        >
            <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
                <span style="color: #3998F7;font-size: 22px">运行计划</span>
                <span>
                <el-button @click="scheduleSubmit" type="primary" size="small">保存</el-button>
                <el-button type="danger" @click="closeDialog1" size="small">取消</el-button>
                </span>
            </div>
            <el-form ref="settingForm" label-width="150px" class="schedule" :model="scheduleInfo" hide-required-asterisk>
                <el-row>
                    <el-col :span="24" >
                        <el-form-item label="任务" >
                            <span style="margin-left:10px;color: #3b99f7;font-size: 16px;width: 100%;height:40px;overflow: hidden;">{{taskName}}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="margin-bottom: 5px">
                        <el-form-item label="运行计划名称" class="home_star" prop="schedule_name" :rules="[
                                           { required: true, message: '运行计划名称不能为空'},
                                    ]">
                            <el-input v-model="scheduleInfo.schedule_name"  placeholder="请输入字段组名称" style="width:calc(100% - 20px)"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="margin-bottom: 5px">
                        <el-form-item label="月份" prop="month">
                            <el-input v-model="scheduleInfo.month" placeholder="请设定任务运行的月份(1-12)" style="width:calc(100% - 20px)"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="margin-bottom: 5px">
                        <el-form-item label="星期几" prop="weekday">
                            <el-input v-model="scheduleInfo.weekday" placeholder="请设定任务运行的星期几(1-7)" style="width:calc(100% - 20px)"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="margin-bottom: 5px">
                        <el-form-item label="日" prop="day">
                            <el-input v-model="scheduleInfo.day" placeholder="请设定任务运行的日期(1-31)" style="width:calc(100% - 20px)"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="margin-bottom: 5px">
                        <el-form-item label="时" prop="hour">
                            <el-input v-model="scheduleInfo.hour" placeholder="请设定任务运行的小时(0-23)" style="width:calc(100% - 20px)"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" style="margin-bottom: 5px">
                        <el-form-item label="分" prop="minute">
                            <el-input v-model="scheduleInfo.minute" placeholder="请设定任务运行的分钟(0-59)" style="width:calc(100% - 20px)"></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="24" style="margin-bottom: 5px">
                        <el-form-item label="秒" prop="second">
                            <el-input v-model="scheduleInfo.second" placeholder="请设定任务运行的秒(0-59)" style="width:calc(100% - 20px)"></el-input>
                        </el-form-item>
                    </el-col> -->
                    <el-col :span="24" style="margin-bottom: 5px">
                        <el-form-item label="说明" prop="comments">
                            <el-input type="textarea" v-model="scheduleInfo.comments"
                                      :rows="2"
                                      placeholder="请输入说明" style="width:calc(100% - 20px)"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" >
                        <el-form-item label="启用" prop="status">
                            <el-switch style="margin-left: 10px"
                                       v-model="scheduleInfo.status"
                                       active-color="#13ce66"
                                       active-value="ACTIVE"
                                       inactive-value = "INACTIVE">
                            </el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

        </el-dialog>
<!--        日志-->
        <el-dialog
                id="log"
                :visible.sync="dialog2"
                width="60%"
                :show-close="false"
        >
            <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
                <span style="color: #3998F7;font-size: 22px">运行日志</span>
                <span>
                <el-button @click="operation" type="primary" size="small">立即运行</el-button>
                <el-button type="danger" @click="closeDialog2" size="small">关闭</el-button>
                </span>
            </div>
            <el-row>
            <span style="color: #3998F7;font-size: 16px;margin-bottom: 10px">{{taskName}}-{{scheduleName}}</span>
            <el-table border style="margin-top: 10px" :data="logTableDate">
                <el-table-column
                        width="200"
                        sortable
                        prop="start_time"
                        label="开始运行时间"
                >
                    <template slot-scope="scope">
                        {{getTime(scope.row.start_time)}}
                    </template>
                </el-table-column>
                <el-table-column
                        width="200"
                        sortable
                        prop="end_time"
                        label="结束运行时间"
                >
                    <template slot-scope="scope">
                        {{getTime(scope.row.end_time)}}
                    </template>
                </el-table-column>
                <el-table-column
                        sortable
                        prop="log_text"
                        label="日志详情">
                        <template slot-scope="scope">
                            <span>{{scope.row.log_text | ellipsis}}</span>
                        </template>
                </el-table-column>
                <el-table-column
                        width="80"
                        sortable
                        prop="success"
                        label="状态">
                    <template slot-scope="scope">
                        <div v-if="scope.row.success=='T'" style="font-weight: bold;color: #7ED321">成功</div>
                        <div v-if="scope.row.success=='F'" style="font-weight: bold;color: #ED3B3F">失败</div>
                    </template>
                </el-table-column>
                <el-table-column
                        width="80"
                        label="操作"
                >
                    <template slot-scope="scope">
                        <el-button @click="downloadTxt(scope.row)" type="primary" size="mini">下载
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-col style="display:flex;justify-content: space-between;align-items: center">
<!--                <span style="font-size: 14px">显示第 1 至 4 项结果，共4项</span>-->
                <pagination :page="page" @changePage="changePageClick"></pagination>
            </el-col>
            </el-row>
        </el-dialog>
    </div>
</template>

<script>
    import pagination from '../../../components/pagination'
    import http from '../../../APIService/http'
    import { MessageBox, Message } from 'element-ui'
    import moment from 'moment'
    export default {
        name: "taskManagement",
        data(){
            return{
                value:true,
                dialog1:false,
                dialog2:false,
                count:{},
                taskArray:[],
                scheduleInfo:{},
                taskName:'',
                taskId:'',
                type:'',
                taskInfo:{},
                logTableDate:[],
                scheduleName:'',
                page: {
                    current: 1,
                    size: 5,
                    total: 0
                },
                // allLog:[],
                schedule_id:"",
                tenant_id:"",
            }
        },
        components:{
            pagination
        },
        created() {
            this.init()
        },
        filters: {
            ellipsis(value) {
                if (!value) return "";
                if (value.length > 100) {
                    return value.slice(0, 100) + "...";
                }
                return value;
            }
        },
        mounted() {
        },
        methods:{
            setting(item,row){
                this.dialog1=true
                this.type='update'
                this.scheduleInfo=JSON.parse(JSON.stringify(row))
                this.taskName=item.task_name
            },
            logBtn(item,row){
                this.schedule_id=row.schedule_id
                this.tenant_id=row.tenant_id
                 this.taskName=item.task_name
                 this.scheduleName=row.schedule_name
                 this.taskInfo=item
                 this.scheduleInfo=row
                 this.logTableDate=row.logArr
                 // this.page.total=row.count.length
                 // this.allLog=row.count
                this.tasksLog()
            },
            addSchedule(taskName,taskId){
                this.dialog1=true
                this.taskName=taskName
                this.taskId=taskId
                this.scheduleInfo={
                    status:'ACTIVE'
                }
                this.type='add'
            },
            closeDialog1(){
                this.dialog1=false
            },
            closeDialog2(){
                this.dialog2=false
            },
            async tasksLog(){
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let data={
                        schedule_id:this.schedule_id,
                        tenant_id:this.tenant_id,
                        limit: this.page.size,
                        offset: this.page.current - 1,
                    }
                    debugger
                    //crm_web_server: /wapi/task/tasksLog
                    //task_manager: /task/tasksLog
                    // await http.post('/wapi/task/tasksLog',data).then(res=>{
                    await http.post('/task/tasksLog',data).then(res=>{
                        if(res.success){
                            this.dialog2=true
                            this.logTableDate = res.data.logArr
                          this.page.total=res.data.count
                            loading.close()
                        }else {
                            Message.error('获取失败');
                        }
                    })

                }catch (err) {
                    loading.close()
                    console.log(`error:${err}`)
                }
            },

            async init(){
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let data={
                        limit: this.page.size,
                        offset: this.page.current - 1,
                        tenant_id:this.$store.getters.getUser.tenant_id
                    }
                    //crm_web_server:/wapi/task/getTaskInfo
                    //task_manager: /task/getTaskInfo
                    // await http.post('/wapi/task/getTaskInfo',data).then(res=>{
                    await http.post('/task/getTaskInfo',data).then(res=>{
                        if(res.success){
                            this.count=res.data.count
                            this.taskArray=res.data.arr
                            for(let i=0;i<this.taskArray.length;i++){
                                let obj=this.taskArray[i]
                                obj.lastOperation=obj.lastOperation?obj.lastOperation:'暂未运行'
                                let schedule=obj.scheduleArr
                                if(schedule.length>0){
                                    for(let j=0;j<schedule.length;j++){
                                        let obj1=schedule[j]
                                        if(obj1.logArr.length>0){
                                            obj1.lastStatus=obj1.logArr[0].success
                                        }
                                        else {
                                            obj1.lastStatus=""
                                        }
                                    }
                                }
                            }
                            loading.close()
                        }else {
                            Message.error('获取失败');
                        }
                    })

                }catch (err) {
                    loading.close()
                    console.log(`error:${err}`)
                }
            },
            scheduleSubmit(){
                let value= this.scheduleInfo
                value.second = 0;
                if(value.minute==null || value.minute=="")
                {
                    value.minute=0;
                }
                if(value.hour==null || value.hour=="")
                {
                    value.hour=0;
                }
                if(value.day>31){
                    Message.error('设定的日期超出范围');
                }else if(value.hour>23){
                    Message.error('设定的时超出范围');
                }else if(value.minute>59){
                    Message.error('设定的分超出范围');
                }else if(value.second>59){
                    Message.error('设定的秒超出范围');
                }else if(value.month>12){
                    Message.error('设定的月份超出范围');
                }else if(value.weekday>7){
                    Message.error('设定的星期几超出范围');
                }else {
                    this.$refs["settingForm"].validate(valid=>{
                        if(!valid){
                            return false
                        }else{
                            this.saveSchedule()
                        }
                    })

                }
            },
            async saveSchedule(){
                try{
                    let data={
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        type:this.type,
                        scheduleObj:this.scheduleInfo,
                        task_id:this.taskId
                    }
                    delete data.scheduleObj.count;
                    delete data.scheduleObj.logArr;
                    //crm_web_server: /wapi/task/saveSchedule
                    //task_manager: /task/saveSchedule
                //    await http.post('/wapi/task/saveSchedule',data).then(res=>{
                   await http.post('/task/saveSchedule',data).then(res=>{
                       if(res.data.success){
                           this.dialog1=false
                           this.init()
                           Message({
                               type: 'success',
                               message: '保存成功'
                           });
                       }else {
                           Message.error('保存失败');
                       }
                   })

                }catch (err) {
                    console.log(`error:${err}`)
                }
            },
            async operation(){
                try {
                    let data={
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        user_id: this.$store.getters.getUser.user_id,
                        taskInfo:{
                          task_id:this.taskInfo.task_id,
                          task_name:this.taskInfo.task_name,
                          task_type:this.taskInfo.task_type,
                          program:this.taskInfo.program
                        },
                        scheduleObj:{
                          schedule_id:this.scheduleInfo.schedule_id,
                          schedule_name:this.scheduleInfo.schedule_name,
                          second:this.scheduleInfo.second,
                          minute:this.scheduleInfo.minute,
                          hour:this.scheduleInfo.hour,
                          day:this.scheduleInfo.day,
                          month:this.scheduleInfo.month,
                          weekday:this.scheduleInfo.weekday,
                        },
                    }
                    debugger
                    //crm_web_server: /wapi/task/operation
                    //task_manager: /task/operation
                    // await http.post('/wapi/task/operation',data).then(res=>{
                    await http.post('/task/operation',data).then(res=>{
                        if(res.data.success){
                            this.dialog2=false
                            this.init()
                            Message({
                                type: 'success',
                                message: '已运行，请稍后查看日志结果'
                            });
                        }else {
                            Message.error('运行失败');
                        }
                    })

                }catch (err) {
                    console.log(`error:${err}`)
                }
            },
            getTime(time){
                if(time){
                    return moment(time).format('YYYY年MM月DD日 HH:mm:ss')
                }else{
                    return ''
                }
            },
            changePageClick(page, size) {
                if (page) {
                    this.page.current = page
                }
                if (size) {
                    this.page.size = size
                }
                // if(this.page.current==1){
                //     this.logTableDate=this.allLog.slice(0,this.page.size)
                // }else {
                //     let val=(this.page.current-1)*this.page.size
                //     this.logTableDate=this.allLog.slice(val,this.page.size*this.page.current)
                // }

              this.tasksLog();
            },
            downloadTxt(row) {
                const element = document.createElement('a')
                element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(row.log_text))
                element.setAttribute('download', '日志详情')
                element.style.display = 'none'
                element.click()
            }
        },
    }
</script>

<style scoped>
    #taskManagement >>> .el-dialog__header {
        border-bottom: 2px dashed #DCDFE6;
        padding: 20px 0 20px 0;
        margin: 20px 20px 10px;
    }
    #setting >>>.el-form-item{
        margin-bottom: 15px;
    }
    #setting >>>.el-form-item__label{
        font-size:14px;
        font-weight: bold;
        color: black;
        text-align: left;
        padding-left: 20px;
    }
    .schedule >>> .home_star label:after{
        content: '*';
        color: #F56C6C;
        margin-left: 4px;
    }
    #setting >>>.el-dialog__body,#log >>>.el-dialog__body{
        padding: 10px 20px;
    }
    #taskManagement >>> tr th:nth-last-child(2) .cell {
        color: #2b92fa;
    }
    #taskManagement >>> .taskManagement_table_cell {
        color: #2b92fa !important;
    }
</style>



// WEBPACK FOOTER //
// src/pages/system/components/taskManagement.vue